export const cloudinaryURL = 'https://api.cloudinary.com/v1_1/';
export const cloudName = 'contestee';

export const AWSURL = 'https://contestee.s3-us-west-1.amazonaws.com/';
export const AWSAccessKey = 'AKIAJBM3XU4HNVVTAOXA';
export const AWSSecretKey = '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';
export const sessionExpiredMsg = "Session Expired";